<template><SimpleModuleDashboard :module-id="Modules.REMITOS" :profile-id="Profiles.PERSONAL" include-php-custom :actions="dashboardActions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Param from '@/config/parameters'
import Helper from '@/handler/helper'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default {
  components: { SimpleModuleDashboard },
  data: () => ({
    Modules,
    Profiles,
    remitFromOrder: Helper.hasParametersAccess(Param.P26),
    remitFromSale: Helper.hasParametersAccess(Param.P27),
  }),
  computed: {
    dashboardActions() {
      let remitTitle = ''
      if(this.remitFromOrder) remitTitle = 'Remitos desde Pedidos'
      if(this.remitFromSale) remitTitle = 'Remitos desde Ventas'
      return [
        { id: 'remits', reference: 'remits', route: 'RemitsStaffRemits', tone: 'primary', title: remitTitle || undefined },
        { id: 'pending', reference: 'pending', route: 'RemitsStaffPending', tone: 'secondary' },
      ]
    },
  },
}
</script>
